import { useState } from "react";
import { Link } from "react-router-dom";
import { Loader2, Mail, ArrowLeft, CheckCircle2 } from "lucide-react";
import { api, formatApiError } from "@/lib/api";
import { useLang } from "@/context/LanguageContext";

export default function ForgotPassword() {
  const { t, lang } = useLang();
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setError(""); setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email, origin_url: window.location.origin, lang });
      setSent(true);
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail));
    } finally { setLoading(false); }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-[#0A0C10] px-4">
      <div className="w-full max-w-sm">
        <div className="mb-8 flex flex-col items-center">
          <img src="/logo.png" alt="Golden Terminal" className="mb-3 h-14 w-14 object-contain" />
          <h1 className="font-heading text-2xl font-bold text-white">{t("fp.title")}</h1>
          <p className="mt-1 text-sm text-slate-500">{t("fp.sub")}</p>
        </div>
        <div className="rounded-2xl border border-slate-800 bg-[#0E1118] p-6 shadow-2xl">
          {sent ? (
            <div className="text-center" data-testid="forgot-sent">
              <CheckCircle2 className="mx-auto mb-3 h-10 w-10 text-emerald-400" />
              <p className="text-sm text-slate-300">{t("fp.sent")}</p>
            </div>
          ) : (
            <form onSubmit={submit} className="space-y-3">
              <div className="relative">
                <Mail className="pointer-events-none absolute left-3 top-3 h-4 w-4 text-slate-500" />
                <input data-testid="forgot-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} placeholder={t("fp.emailPh")}
                  className="w-full rounded-lg border border-slate-700 bg-[#11141A] py-2.5 pl-10 pr-3 text-sm text-white placeholder-slate-500 outline-none focus:border-blue-500" />
              </div>
              {error && <p className="rounded-md bg-red-500/10 px-3 py-2 text-xs text-red-400">{error}</p>}
              <button data-testid="forgot-submit" type="submit" disabled={loading}
                className="flex w-full items-center justify-center gap-2 rounded-lg bg-blue-600 py-2.5 text-sm font-semibold text-white transition-colors hover:bg-blue-500 disabled:opacity-60">
                {loading && <Loader2 className="h-4 w-4 animate-spin" />} {t("fp.send")}
              </button>
            </form>
          )}
        </div>
        <Link to="/login" className="mt-5 flex items-center justify-center gap-1.5 text-sm text-slate-500 hover:text-slate-300">
          <ArrowLeft className="h-4 w-4" /> {t("fp.back")}
        </Link>
      </div>
    </div>
  );
}
